import { actions as appActions } from '../features/App/reducer'
import { getIsLoading } from '../features/App/selectors'

export const onIsLoading = (isLoading: boolean) => {
  const _isLoading = getIsLoading(window.store.getState())
  if (isLoading !== _isLoading)
    window.store.dispatch(appActions.onIsLoading(isLoading))
}
